// extracted by mini-css-extract-plugin
export default {"programBenefits":"styles_programBenefits__98gSg","title":"styles_title__7EvOX","keypoints":"styles_keypoints__o7ZE6","desc":"styles_desc__BtpcW"};